module.exports = __webpack_public_path__ + "img/group.aa4ce577.png";